<template>
    <div class="page-content">
        <div v-show="working > 0" class="lds-facebook"><div></div><div></div><div></div></div>
        <div class="wrap-form">
            <div>
                <input type="checkbox" id="remove-empty" v-model="removeEmpty"><label for="remove-empty">Remove if empty?</label>
                <input type="checkbox" id="remove-dupes" v-model="removeDupes"><label for="remove-dupes">Remove dupes?</label>
                <span class="combo">
                    <button class="undoredo" v-on:click="unDo" v-bind:disabled="historyIndex <= 0">&#8592;</button>
                    <button class="misc" v-bind:disabled="history.length < 2">history</button>
                    <button class="undoredo" v-on:click="reDo" v-bind:disabled="(historyIndex === (history.length - 1)) || history.length === 0">&#8594;</button>
                </span>
            </div>
            <div>
                <textarea rows="10" cols="150" autocapitalize="off" spellcheck="false" autocomplete="off" v-model="text1" name="text-tools"></textarea>
            </div>
            <div class="buttons">
                <button v-on:click="union">&#8746;</button>
                <button v-on:click="intersection">&#8745;</button>
                <button v-on:click="exclude">&#8746;-&#8745;</button>
                <div class="textarea-accessory">
                    <span>{{first.length}} lines</span>
                    <button><file-text-icon></file-text-icon></button>
                    <button class="green" v-on:click="''"><file-plus-icon></file-plus-icon></button>
                    <button class="red" v-on:click="''"><file-minus-icon></file-minus-icon></button>
                </div>
            </div>
            <div><textarea rows="10" cols="150" autocorrect="off" autocapitalize="off" spellcheck="false" autocomplete="off" v-model="text2" name="text-tools"></textarea></div>
            <div class="buttons">
                <button v-on:click="union_uniq">uniq(result)</button>
                <div class="textarea-accessory">
                    <span>{{second.length}} lines</span>
                    <button><file-text-icon></file-text-icon></button>
                    <button class="green" v-on:click="''"><file-plus-icon></file-plus-icon></button>
                    <button class="red" v-on:click="''"><file-minus-icon></file-minus-icon></button>
                </div>
            </div>
            <template v-show="result.length != 0">
                <div><textarea rows="10" cols="150" v-model="resultText" name="resultText" readonly></textarea></div>
                <div>
                    <div class="textarea-accessory">
                        <span>{{result.length}} lines</span>
                        <button><file-text-icon></file-text-icon></button>
                        <button class="green" v-on:click="''"><file-plus-icon></file-plus-icon></button>
                        <button class="red" v-on:click="''"><file-minus-icon></file-minus-icon></button>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import Storages from 'js-storage'

    import {FileTextIcon, FileMinusIcon, FilePlusIcon} from 'vue-feather-icons'

    export default {
        name: "Compare",
        components:{
            FileTextIcon,
            FileMinusIcon,
            FilePlusIcon
        },
        data: function (){
            return {
                saveHistory: true,
                historyIndex: 0,
                history: [],
                removeEmpty: '',
                removeDupes: '',
                result: [],
                working: 0,
                first: [],
                second: [],
                text1: '',
                text2: '',
            }
        },
        watch:{
            text1: function (val) {
                this.first = val.split('\n');
                Storages.localStorage.set('Compare:text1', this.text1);
            },
            text2: function (val) {
                this.second = val.split('\n');
                Storages.localStorage.set('Compare:text2', this.text2);
            },
            removeEmpty: function (val) {
                Storages.localStorage.set('Compare:removeEmpty', this.removeEmpty);
            },
            removeDupes: function (val) {
                Storages.localStorage.set('Compare:removeDupes', this.removeDupes);
            },
            result: function (val) {
                if (this.saveHistory) {
                    if (this.historyIndex !== (this.history.length - 1)){
                        this.history = this.history.slice(0, this.historyIndex + 1);
                    }
                    this.history.push(this.result);
                    this.historyIndex = this.history.length - 1;
                }
            }
        },
        computed: {
            resultText: function () {
                let tmp = this.result;

                if (this.removeDupes){
                    tmp = uniq(tmp);
                }

                if (this.removeEmpty) {
                    tmp = tmp.filter(item => {return item != ''})
                }

                return tmp.join('\n');
            }
        },
        mounted: function(){
            this.removeEmpty = Storages.localStorage.isSet('Compare:removeEmpty')?Storages.localStorage.get('Compare:removeEmpty'):'';
            this.removeDupes = Storages.localStorage.isSet('Compare:removeDupes')?Storages.localStorage.get('Compare:removeDupes'):'';
            this.text1 = Storages.localStorage.isSet('Compare:text1')?Storages.localStorage.get('Compare:text1'):'';
            this.text2 = Storages.localStorage.isSet('Compare:text2')?Storages.localStorage.get('Compare:text2'):'';
        },
        methods: {
            unDo: function (){
                if (this.historyIndex == 0){return}
                this.historyIndex--;
                this.result = this.history[this.historyIndex];
            },
            reDo: function(){
                if (this.historyIndex == (this.history.length - 1)){return}
                this.historyIndex++;
                this.result = this.history[this.historyIndex];
            },
            union: function () {
                this.result = this.first.concat(this.second);
            },
            union_uniq: function () {
                this.result = uniq(this.first.concat(this.second));
            },
            intersection: function () {
                this.result = this.first.filter((item) => {
                    return this.second.indexOf(item) !== -1;
                });
            },
            exclude: function () {
                this.result = this.first.filter((item) => {
                    return this.second.indexOf(item) === -1;
                }).concat( this.second.filter((item) => {
                    return this.first.indexOf(item) === -1;
                }));
            }
        }
    }
</script>

<style scoped>
    div.buttons{
        margin-bottom: 1rem !important;
    }

    .page-content textarea{
        flex: none;
        margin: 0;
        width: unset;
    }

    .combo{
        display: flex;
        margin-right: 0.5rem;
        background-color: #CCCCCC;
        color: #ffffff;
    }

    .combo button{
        min-width: 2rem;
        margin: 0;
        font-weight: bold;
        font-size: 0.6rem;
    }

    .combo button:first-of-type{
        z-index: 100;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
    }

    .combo button:last-of-type{
        z-index: 10;
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
    }

    .combo button.misc:disabled{
        background: none;
        box-shadow: none;
        color: #555555;
    }

    .combo button.misc{
        color: #ed0028;
        padding: 0.5rem;
        margin: 0;
        background: #bdc3c7;
        /* background: linear-gradient(to top, #ff7a2c, #bdc3c7, #bdc3c7,#bdc3c7, #83a8be); */
        background: -webkit-gradient(linear, left bottom, left top, from(#ff7a2c), to(#ffaf4f));
        background: linear-gradient(to top, #ff7a2c, #ffaf4f);
        box-shadow: inset 0px 0px 5px 2px #d04242;
        border-style: outset;
        border-radius: 0;
        border-right: 0;
        border-bottom: 1px solid #FFF;
        border-left: 0;
        border-top: 1px solid #5a5a5a;
        outline: none;
        transition: 0.5s;
    }

    #content{
        flex-wrap: wrap;
    }

    .side{
        width: unset;
        border-right: none;
        border-bottom: none;
    }

    .textarea-accessory{
        text-align: right;
        margin: 0;
        align-items: center;
        justify-content: flex-end;
        font-family: monospace;
        flex: 1;
    }

    .textarea-accessory button:last-of-type{
        margin-right: 0;
    }

    .textarea-accessory span{
        margin: 0 0.5rem;
        color: #ffffff;
        text-shadow: -1px 1px 0px #4e1b14;
    }

    .page-content > .wrap-form > div{
        margin: 0.25rem;
        display: flex;
        flex-direction: row;
        align-items: center;
    }
</style>
